export const qaLabelDispatch = {
    newJobBtn: '#new-job-button', // id by Antonio -> refactor to use data-testid
    /* Create Job Modal */
    createJobModalTitle: 'job--new-job-modal--title',
    jobPanel: {
        filterIcon: 'dispatch--jobs-panel--filter-button',
        filterText: 'dispatch--jobs-panel--showing-filter-text',
        loadingJobsText: 'dispatch--jobs-panel--loading-jobs-text'
    },
    /* Job List */
    jobList: {
        jobCardJobName: '[data-job-name="${job.name}"]',
        offeredDriversText:'job--offered-drivers-text',
        assignBtn: 'job-assign-btn'
    },
    /* Assign Job modal */
    assignJobModal: {
        title: 'dispatch--assign-job-modal--title',
        dispatchDropdownDiv: 'dispatch--assign-job-modal--dispatch-div',
        driversDropdownLabel: 'dispatch--assign-job-modal--drivers-label',
        driversInTeamsDropdownLabel:'dispatch--assign-job-modal--drivers-in-teams-label',
        assignJobBtn: 'dispatch--assign-job-modal--assign-btn',
        dispatchDropdownOption: '#react-select-dispatch-mode-select-option'
    },

    /* Job Details */
    jobDetailsCard: {
        jobTitle: 'dispatch--jobs-details--order-number-title',
        jobId: 'dispatch--jobs-details--order-id',
        jobFleetId: 'dispatch--jobs-details--order-fleetId',
        jobContact: {
            jobCardCustomerName: 'dispatch--jobs-details--customer-name',
            jobCardCustomerPhone: 'dispatch--jobs-details--customer-phone',
            jobCardCustomerEmail: 'dispatch--jobs-details--customer-email'
        },
        jobDeliveryInstructions: 'dispatch--jobs-details--delivery-instructions-description',
        jobTrackingLink: 'dispatch--jobs-details--tracking-link',
        jobOrderItemsTable: 'dispatch--jobs-details--order-items-table',
        jobSite: 'dispatch--jobs-details--site',
        jobActionsEditJobBtn: 'dispatch--jobs-details--actions--edit-job-btn',
        jobActionsStartJobBtn: 'dispatch--jobs-details--actions--update-job-btn',
        jobAttributesTable: 'dispatch--jobs-details--table',
        jobTasksStatus: 'dispatch--job-details--tasks--task-detail-status',
        jobOrderValue: 'dispatch--jobs-details--order-value',
        jobDispatchesPanel: 'dispatch--jobs-details--dispatches-panel',
        jobDispatchesRow: 'dispatch--jobs-details--dispatches-row',
        jobCloseBtn: 'dispatch--jobs-details--close-btn',
        closeBtn: '#close-view-job-pane'
    },
    jobExpandedContentActions: {
        viewDetailsBtn: 'dispatch--jobs-expanded-content--actions-menu--view-details-btn',
        assignBtn: 'dispatch--jobs-expanded-content--actions-menu--assign-btn',
        editBtn: 'dispatch--jobs-expanded-content--actions-menu--edit-btn',
        addIssueBtn: 'dispatch--jobs-expanded-content--actions-menu--issue-btn',
        cancelBtn: 'dispatch--jobs-expanded-content--actions-menu--cancel-btn',
        duplicateBtn: 'dispatch--jobs-expanded-content--actions-menu--duplicate-btn',
        recallBtn: 'dispatch--jobs-expanded-content--actions-menu--recall-btn',
        reallocateBtn: 'dispatch--jobs-expanded-content--actions-menu--reallocate-btn',
        messageDriverBtn: 'dispatch--jobs-expanded-content--actions-menu--msg-driver-btn',
        viewTrackingLinkBtn: 'dispatch--jobs-expanded-content--actions-menu--view-tracking-link-btn'
    },
    driverPanel: {
        filterIcon: 'dispatch--drivers-panel--filter-button',
        driversList: 'dispatch--drivers-panel--drivers-list-div'
    },
    driverFilterModal: {
        title: 'dispatch--driver-filter-modal--title',
        availabilityDropdown: 'dispatch--driver-filter-modal--availability-dropdown',
        teamsDropdown: 'dispatch--driver-filter-modal--teams-dropdown',
        applyFiltersBtn: 'dispatch--driver-filter-modal--apply-filters-btn'
    },
    jobFilterModal: {
        title: 'dispatch--jobs-filter-modal--title',
        jobStatusLabel: 'dispatch--jobs-filter-modal--job-status-label',
        applyFiltersBtn: 'dispatch--jobs-filter-modal--apply-filters-button'
    },
    jobCardArrow: '[data-job-name="${job.name}"] .fal',

    submitBtn: '#dispatch-submit-button',

    newJobModal: {
        titleForSite: 'dispatch--new-job-modal-for-site-title',
        titleForScratch: 'dispatch--new-job-modal-for-scratch-title',
        customerNameInput: 'dispatch--new-job-modal--customer-name-input', // for both types of jobs
        phoneNumberBtn: 'dispatch--new-job-modal--customer-phone-btn',
        phoneNumberInput: '[data-test-id="src_reacttelephoneinput_test_id_5"]',
        emailBtn: 'dispatch--new-job-modal--customer-email-btn',
        emailInput: 'dispatch--new-job-modal--email-input',
        dropOffAddressInput: 'dispatch--new-job-modal--drop-off-address-input',
        dropOffAddressLabel: 'dispatch--new-job-modal--drop-off-address-label',
        orderNumberInput: 'dispatch--new-job-modal--order-number-input',
        saveAndFinishButton: 'dispatch--new-job-modal--save-n-finish-button',
        saveButton: 'dispatch--new-job-modal--save-button',
        addOrderValueBtn: 'dispatch--new-job-modal--add-order-value-btn',
        orderValueInput: 'dispatch--new-job-modal--order-value-input',
        orderValueCurrencyDropdown: 'dispatch--new-job-modal--order-value-currency-dropdown',
        orderValueCurrencyOption: 'dispatch--new-job-modal--order-value-currency-option', //'dropdown-item-',
        pickupNowInput: 'dispatch--new-job-modal--pickup-now-input',
        scheduleInput: 'dispatch--new-job-modal--pickup-schedule-input',
        itemsInput: 'dispatch--new-job-modal--item-input',
        addItemBtn: 'dispatch--new-job-modal--add-item-btn',
        restrictedItemsCheckbox: 'dispatch--new-job-modal--restricted-items-checkbox',
        deliveryInstructionsTextBox: 'dispatch--new-job-modal--delivery-instructions-textbox',
        // job from scratch
        campaignDropdown: 'dispatch--new-job-modal--campaign-dropdown',
        policyDropdown: 'dispatch--new-job-modal--policy-dropdown',
        groupDropdown: 'dispatch--new-job-modal--group-dropdown',
        addTaskButton: 'dispatch--new-job-modal--add-task-btn',
        deadlineDiv: 'dispatch--new-job-modal--add-deadline-div',
        deadlineInput: 'dispatch--new-job-modal--add-deadline-input', // not used
        nameInput: 'dispatch--new-job-modal--name-input',
        addressInput: 'dispatch--new-job-modal--address-input',//not used
        addressDiv: 'dispatch--new-job-modal--address-div',

        taskModal: {
            saveBtn: 'dispatch--new-job-modal--task-modal--save-task-btn',
            requirementsCheckbox: 'dispatch--new-job-modal--task-modal--requirements-checkbox',
            taskTypeRadioBtn: 'dispatch--new-job-modal--task-modal--radio',
        },

        //Metadata
        metadataTab: 'dispatch--new-job-modal--',
        metadataTableBody: 'dispatch--new-job-modal--metadata-table-body',
        metadataAddPropertyBtn: 'dispatch--new-job-modal--metadata--add-property-btn',
        metadataPropertyNameInput: 'dispatch--new-job-modal--metadata--name-input',
        metadataPropertyValueInput: 'dispatch--new-job-modal--metadata--value-input',
        metadataSavePropertyBtn: 'dispatch--new-job-modal--metadata--save-property-btn',
    },
    editJobModal: { 
        // Edit task
        tasksList: 'dispatch--edit-job-modal--tasks-list-div',
        tasksItem: 'dispatch--edit-job-modal--tasks-list-item',
        requirementItem: 'dispatch--edit-job-modal--tasks-requirement',
        removeTaskBtn: 'dispatch--edit-job-modal--task--remove-btn',
    },
    cancelJobModal:{
        title:  'dispatch--cancel-job-modal--title',
        cancelReasonlabel: 'dispatch--cancel-job-modal--reason-label',
        cancelCommentTextBox: 'dispatch--cancel-job-modal--cancel-textbox',
        cancelJobBtn:'dispatch--cancel-job-modal--cancel-btn'
    },
    addIssueModal:
    {
        issueWarningLabel:'dispatch--add-issue-modal--issue-warning-label',
        issueDropdown:'dispatch--add-issue-modal--issue-dropdown',
        addIssueBtn:'dispatch--add-issue-modal--add-issue-btn'
    },
    duplicateJobModal:
    {
        duplicateOptions:'dispatch--duplicate-modal--duplicate-options--input',
        title:'dispatch--duplicate-modal--title',
        duplicateBtn:'dispatch--duplicate-modal--duplicate-btn'
    },
    recallJobModal:
    {
        title:'dispatch--recall-modal--title',
        recallBtn:'dispatch--recall-modal--recall-btn'
    },
    chatWindow:
    {
        messageTextBox:'dispatch--chat--message-textbox',
        chatHistory:'dispatch--chat--history-div',
        closeBtn:'dispatch--chat--close-btn',
        //header
        driverNameInfoHeader:'dispatch--chat--driver-div',
        jobNameInfoHeader:'dispatch--chat--job-name-div'
    }
};
